<script>
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let meeting;

	function updateCashoutEnabled(e) {
		MeetingStore.updateMeetingCashoutEnabled(meeting.id, e.target.checked)
			.then(() => {
				notify({
					type: 'success',
					title: `${meeting.name}`,
					message: `"Cash Out" for Meeting updated to "${e.target.checked ? 'ON' : 'OFF'}"`,
					timeout: 3
				});
			})
			.catch(() => {
				notify({
					type: 'danger',
					title: `${meeting.name}`,
					message: 'Failed to update Meeting "Cash Out"',
					timeout: 3
				});
			});
	}
</script>

<div class="ml-4 mr-2 font-semibold uppercase">Cash out</div>
<Switch
	on:change={updateCashoutEnabled}
	name={`cashout-enabled_meeting-${meeting.id}`}
	checked={meeting.cashout_enabled}
	small={true}
/>
